module.exports = __webpack_public_path__ + "img/mile2m-m@2.34810af1.webp";